import { withTranslation } from "next-i18next";
import Link from "@components/core/Link";

function SupportSection({ supportFeaturedQuestions, t }) {
  function displaySupportFeaturedQuestions() {
    return supportFeaturedQuestions.map((supportFeaturedQuestion) => (
      <Link
        key={supportFeaturedQuestion.id}
        href={`/help/support/${supportFeaturedQuestion.slug}`}
        className="link-primary no-underline"
      >
        {supportFeaturedQuestion.title}
      </Link>
    ));
  }

  return (
    <div className="w-100 bg-white pt-2 flex-1 d-flex flex-column justify-content-between">
      <div className="px-3 py-4">
        <div className="mb-4">
          <h2 className="h3 mb-0">{t("help:help_center.support.title")}</h2>
          <p className="mb-0 font-size-sm">{t("help:help_center.support.subtitle")}</p>
        </div>
        <div className="d-flex flex-column gap-4">
          {displaySupportFeaturedQuestions()}
        </div>
      </div>

      <div className="border-top py-3 d-flex">
        <Link href="/help/overview-support" className="link-primary no-underline text-center mx-auto">
          {t("help:help_center.support.get_help")}
        </Link>
      </div>
    </div>
  );
}

export default withTranslation("help")(SupportSection);